













import Vue from 'vue'
import { setSearchQuery, search, getSuggestions } from '../store/actions';
import { routerReplace } from '../helpers';
import { EventBus } from '../helpers/EventBus.vue' 
interface SearchInputData {
    query: string
}   

interface SearchInputMethods {
	useSuggestion(suggestion: string): void
    search(): void
    goToSuggestions(event: any): void
    nextSuggestion(event: any): void
    previousSuggestion(event: any): void
    goToButton(event: any): void
}

interface SearchInputComputed {	
	searchQuery?: string
    suggestions: string[]
    show: boolean
}

export default Vue.extend<SearchInputData, SearchInputMethods, SearchInputComputed , {}>({
	name: 'SearchInput',
	props: {
		article: {}
	},
    // data() {
    //     return {
    //         query: ''
    //     }
    // },
    // methods: {
    //     setSearchQuery() {
    //         this.$store.dispatch(setSearchQuery({query: this.query}))
    //         routerReplace({
	// 			query: this.$store.getters.getParams
	// 		})
    //         EventBus.$emit('scrollToTop');
    //     }
    // },
    computed: {  
        searchQuery: {
			set(value) {
                const queryString = value ? value : ''
                this.$store.dispatch(setSearchQuery({query: queryString, skipSearch: true}))
                this.$store.dispatch(getSuggestions(queryString))
                
			},
			get() {
				return this.$store.getters.query
			}
		},
        suggestions() {
            return this.$store.getters.suggestions
        },
        show() {
            return this.$store.getters.showSuggestions
        }
    },
    methods: {
        search() {
            this.$store.dispatch(search(false))
            routerReplace({
                query: this.$store.getters.getParams
            })

            EventBus.$emit('scrollToTop');
        },
        useSuggestion(suggestion) {
            this.$store.dispatch(setSearchQuery({query: suggestion, skipSearch: false}))
        },
        goToSuggestions(e) {
            e.preventDefault();
            const list = this.$refs.suggestions as HTMLElement;
            const first = list.querySelector('li');
            if(first) {
                first.focus();
            }
            
        },
        nextSuggestion(e) {
            e.preventDefault();
            const next = e.currentTarget.nextElementSibling;
            if (next) {
                next.focus();
            }
        },
        previousSuggestion(e) {
            e.preventDefault();
            const previous = e.currentTarget.previousElementSibling;
            if (previous) {
                previous.focus();
            }
        },
        goToButton(e) {
            e.preventDefault();
            const submit = this.$refs.submit as HTMLInputElement;
            if(submit) {
                submit.focus();
            }
        }
    }
})
